import { ContentNode } from '@helo/cms'

import { Icon, IconProps } from '../../components/Icons/Icon'
import { SkeletonCircle } from '../../components/SkeletonLoader'
import { createWidget } from '../widget-utils'

export const IconWidget = ({
  isLoading,
  contentNode,
  boxSize = '24px',
  color = 'currentColor',
  ...props
}: IconProps & { isLoading?: boolean; contentNode?: ContentNode }) => {
  if (isLoading) {
    return <SkeletonCircle isLoading size={boxSize} />
  }

  return <Icon boxSize={boxSize} color={color} {...props} />
}

export const IconWidgetDefinition = createWidget(IconWidget, { type: 'Icon' })
